const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan2d from './img-3.jpg';
import floorplan3d from './img-38.jpg';

const floorPlanFiles = new Set(['./img-3.jpg', './img-38.jpg']);

const sorted = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const klecanyImages: string[] = sorted;

export const klecanyFloorPlans = [
  { image: floorplan3d, label: "Půdorys bytu – 3D" },
  { image: floorplan2d, label: "Půdorys bytu – 2D" },
];
